angular
    .module('octopusApp.infrastructure')
    .directive("octoFeature", function(octopusFeatures) {
        return {
            restrict: 'A',
            replace: false,
            link: function ($scope, $element, attr) {
                if (!attr.octoFeature) {
                    return;
                }

                $scope.$watch(function () {
                    return octopusFeatures.isEnabled(attr.octoFeature);
                }, function (isEnabled) {
                    if (isEnabled) {
                        $element.removeClass('octo-feature-denied');
                    } else {
                        $element.addClass('octo-feature-denied');
                    }
                });
            }
        };
    });


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo_feature.js
// module id = 3744187900486927
// module chunks = 1